/** @enum {string} */
export const errorKeys = {
  providerFailure: 'social-fund-provider-failure',
  sslServerFailure: 'social-fund-ssl-server-failure',
  noResponse: 'social-fund-no-response',
  invalidRequest: 'social-fund-invalid-request',
  invalidClientData: 'social-fund-invalid-client-data',
  wrongPin: 'social-fund-wrong-pin',
  noPinUser: 'social-fund-no-pin-user',
  requestDeclined: 'social-fund-request-declined',
  wrongOtpCode: 'social-fund-wrong-otp-code',
  requestVerifiedAlready: 'social-fund-request-verified-already',
  noPermission: 'social-fund-no-permission',
};

/** @enum {string} */
export const consentStatuses = {
  noCode: 'no_code',
  pending: 'pending',
  waitingForVerification: 'waiting_for_verification',
  initiated: 'initiated',
  error: 'error',
  valid: 'valid',
  failed: 'failed',
};

/** @enum {string | *} */
export const SocialFundApi = {
  check_social_fund_status: 'social-fund-api/checkSocialFundStatus',
  confirm_social_fund_consent: 'social-fund-api/confirmSocialFundConsent',
  request_otp_code: 'social-fund-api/requestOtpCode',
};

export const SocialFundRoutes = {
  social_fund: 'social-fund',
  social_fund_loading: 'social-fund-loading',
};

export const notifier = {
  position: 'top-center',
  duration: 10000,
};

export const localStorageKey = 'expiredTime';
